import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import WidgetColumn from './widget-column'
import { subscribe } from '../../../../utils/globals'
import Axios from 'axios'
// eslint-disable-next-line import/no-internal-modules
import tracker from '../../../../components/tracker/publish'
// eslint-disable-next-line import/no-internal-modules
import browser from '../../../../libs/helpers/browser-detection'
import { ServerGenericPageWidget, FULL_WIDTH_CONTAINER } from '@insided/customization'
import Button from '@insided/control/uikit/Button'
import classNames from 'classnames'

export type pageOptions = 'homepage' | 'ideation' | 'productUpdates' | 'knowledgeBase' | 'community'

interface Props {
  page: pageOptions
  elements: ServerGenericPageWidget[]
  controlUrl: string
}

export type ElementChange = Pick<ServerGenericPageWidget, 'type' | 'config' | 'title'>

export interface DonePayload {
  idx: number
  element: ElementChange
}
export interface MovePayload {
  direction: 'up' | 'down'
}
export type VisiblePayload = boolean

interface State {
  elements: ServerGenericPageWidget[]
  expanded: boolean
  hideToolbar: boolean
  isPublishing: boolean
}

/**
 * @deprecated use data-qa attribute
 */
const DEPRECATED_QA_CLASSNAMES = 'qa-save-customization btn--insided-brand'

export default class CustomizationToolbar extends Component<Props, State> {
  counter: number
  constructor(props: Props) {
    super()
    this.state = {
      elements: props.elements.map((el, idx) => ({
        ...el,
        id: idx
      })),
      isPublishing: false,
      expanded: true,
      hideToolbar: false
    }

    this.counter = 1

    subscribe('edit_column', (payload) => {
      this.setState({ hideToolbar: payload.editing })
    })

    this.publishChanges = this.publishChanges.bind(this)
  }

  componentDidMount() {
    setInterval(() => {
      ++this.counter
    }, 60000)
  }

  trackPublishEvent() {
    const isHtmlWidgetEnabled =
      this.state.elements.filter((element) => element.type === 'html_widget' && element.active).length > 0
    const viewport = `${window.innerWidth}*${window.innerHeight}`
    tracker.trackEvent('userevent', {
      type: 'Destination Configuration Mode Published',
      browser: browser,
      viewport: viewport,
      html_widget_enabled: isHtmlWidgetEnabled,
      session_time: this.counter
    })
  }

  trackCancelEvent() {
    const viewport = `${window.innerWidth}*${window.innerHeight}`
    tracker.trackEvent('userevent', {
      type: 'Destination Configuration Mode Cancelled',
      browser: browser,
      viewport: viewport,
      session_time: this.counter
    })
  }

  async publishChanges() {
    this.setState(
      {
        isPublishing: true
      },
      async () => {
        this.trackPublishEvent()
        try {
          await Axios.post('/branding/updateWidgets', {
            elements: this.state.elements,
            page: this.props.page
          })
        } finally {
          this.setState({
            isPublishing: false
          })
        }
        window.location.search = ''
      }
    )
  }

  render() {
    return (
      <div
        className={classNames('translation--switch', 'customization-toolbar', {
          'is-hidden': this.state.hideToolbar
        })}
      >
        <div
          className={classNames('customization-toolbar__expanded-controls', {
            'customization-toolbar__expanded-controls--expanded': this.state.expanded
          })}
        >
          <span className='customization-toolbar__dot' />

          <span style={{ marginRight: '16px' }}>Customization Mode</span>

          <Button
            variant='primary'
            disabled={this.state.isPublishing}
            onClick={this.publishChanges}
            data-qa='customization-toolbar-publish'
            className={DEPRECATED_QA_CLASSNAMES}
          >
            Publish
          </Button>
          <Button
            variant='secondary'
            data-qa='customization-toolbar-cancel'
            onClick={() => {
              this.trackCancelEvent()
              window.location.search = ''
            }}
          >
            Cancel
          </Button>
        </div>

        <Button
          variant='text'
          noMargin
          IconProps={{
            size: 24
          }}
          icon={this.state.expanded ? 'chevronRight' : 'chevronLeft'}
          onClick={() => this.setState({ expanded: !this.state.expanded })}
        />
        <WidgetColumn
          classPrefix='widget-container--index-'
          container='.body-wrapper'
          controlUrl={this.props.controlUrl}
          containerComponent={FULL_WIDTH_CONTAINER}
          elements={this.state.elements}
          onChange={(elements) => this.setState({ elements })}
          nested={false}
          currentPage={this.props.page}
        />
      </div>
    )
  }
}
